export const SUPPORT_PHONE = '(833) 670-5552';

export const LOGIN_ROUTES = {
  staging: 'https://staging-app.vida.com/login/',
  production: 'https://app.vida.com/login/',
} as const;

// Server-defined legal-document `key`s used to populate the legacy
// customerProfile booleans (`termsAndConditionsAccepted` /
// `informedConsentAccepted`). Each booleans is "is the group anchored on this
// key checked?" — see isLegalKeyAgreed.
export const LEGAL_KEY = {
  TERMS: 'terms_of_use',
  CONSENT: 'informed_consent_for_telehealth_services',
} as const;
